import { Box, IconButton, Typography } from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { useNavigate } from "react-router-dom";
import { getColor } from "../style/color/color";
import { fonts } from "../style/fonts/fonts";

export const PageTitle = ({ PageTitle }) => {
  const navigation = useNavigate();
  return (
    <Box
      sx={{
        display: "flex",
        mt: "5px",
        mr: 4,
      }}
    >
      <IconButton sx={{ p: 0 }} onClick={() => navigation(-1)}>
        <ArrowBackIcon
          fontSize="medium"
          sx={{
            mt: "10px",
            color: getColor.NeutralDark700,
          }}
        />
      </IconButton>

      <Typography
        sx={{
          color: getColor.black,
          fontSize: "20px",
          fontFamily: fonts.manrope,
          fontWeight: 700,
          mt: "11px",
          ml: "7px",
        }}
      >
        {PageTitle}
      </Typography>
    </Box>
  );
};
